import useSWR, { SWRResponse } from 'swr';

import { api } from '../utils';

export const useQuery = (
  url: string,
  fn?: (arg: string) => any,
  config: any = {}
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
): SWRResponse<any, any, any> => {
  const fetcher = fn || api.get.bind(api);

  const { data, ...rest } = useSWR(url, fetcher, {
    keepPreviousData: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    ...config,
  });

  return { ...rest, data: (data as { data: string })?.data };
};
